import { t } from 'src/viewLayer/helpers/translations';
import { LOCALE_SUBDOMAIN_MAPPING } from './localeMapping';

export const allAvailableLocales: string[] = Object.keys(LOCALE_SUBDOMAIN_MAPPING);

export const getTranslatedName = (locale: string): string => t(`locales.${locale}`);
